import { Drawer, Menu } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import menus, { sideMenuItensIconsStyle } from "../../components/menu/Menus"
import logo from '../../../assets/logo.png'
import { useContext } from "react";
import { LoginOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import { displayMessage } from '../../services/helper'

export default function DrawerMenu() {
  const {
    setLoggedUser, windowHeight,
  } = useContext(GeneralContext)

  const [collapsed, setCollapsed] = useState(false);
  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [menu_selected_keys, setMenuSelectedKeys] = useState([])
  const [menu_selected_title, setMenuSelectedTitle] = useState([])

  const handleOnClickLogout = () => {
    setLoggedUser(false)
  }

  const handleOnClickItemMenu = e => {
    setMenuSelectedKeys([e.key])
    setMenuSelectedTitle([e.item.props.title])
    onCloseDrawer()
  }

  const onCloseDrawer = () => setMenuDrawerVisible(false)
  const onOpenDrawer = () => setMenuDrawerVisible(true)

  const menuOptions = menus.patientMenuItems

  const listMobileMenuItens = [
    ...menuOptions.map(
      item => {
        return {
          key: item.key,
          label: (
            <Link
              className={`${menu_selected_keys && menu_selected_keys[0] == item.key ? 'text-appian-blue_5 font-bold' : 'text-white font-normal'} text-base flex items-center gap-5`}
              to={item.key}
            >
              <div className="flex items-center gap-4">
                {item.icon}
                <span>{item.title}</span>
              </div>
            </Link>
          )
        }
      }
    ),

    {
      key: '/logout/patient',
      label: (
        <Link
          className="text-white text-base font-normal"
          to={'/login/patient'}
          onClick={handleOnClickLogout}
        >
          <div className="flex items-center gap-4">
            <LoginOutlined style={sideMenuItensIconsStyle} />

            <span>{displayMessage('LOGOUT')}</span>
          </div>
        </Link>
      )
    }
  ]

  return (
    <div>
      <MenuUnfoldOutlined
        className="absolute top-6 left-5 text-2xl ml-15 text-appian-blue_5 cursor-pointer"
        onClick={onOpenDrawer}
      />
      <Drawer
        title={<TitleDrawer />}
        onClose={onCloseDrawer}
        placement="left"
        visible={menuDrawerVisible}
      >
        <Menu
          mode="inline"
          defaultOpenKeys={['menu']}
          className={`h-full ${collapsed ? 'h-'[windowHeight - 71] : 'h-'[windowHeight - 112]} border-r-0 bg-appian-blue pt-2 landscape:scroll landscape:h-96`}
          items={listMobileMenuItens}
          onSelect={handleOnClickItemMenu}
        />
      </Drawer>
    </div>
  )
}

const TitleDrawer = () => (
  <div className="flex flex-row justify-center mb-0">
    <p className="mr-3 pt-6">{displayMessage('MENU')}</p>
    <img
      width={'30%'}
      className="mt-3 p-0"
      src={logo}
    />
  </div>
)
